import React from "react";
import { FaLinkedin, FaTelegramPlane } from "react-icons/fa";
import { ImFacebook2 } from "react-icons/im";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FiPhone } from "react-icons/fi";
import { IoMailOutline } from "react-icons/io5";
import Arbitrator_new_logo_eng from "../../assets/images/new-logo-blue.svg";
import Arbitrator_new_logo_ru from "../../assets/images/new-logo-ru-blue.svg";
import Arbitrator_new_logo_uz from "../../assets/images/new-logo-uz-blue.svg";
import HeaderResponsiveWithProvider from "./header-responsive";
import { useAppSelector } from "../../store";
import { Dropdown, MenuProps, Space } from "antd";
import LogoutButton from "../logout_button";
import { FILE_URL } from "../../config/utils"; 
import Avatar from "../../assets/images/avatar.png";
import { AiFillInstagram } from "react-icons/ai";

type IHeaderWidth = {
  width?: number | string;
};

const Header: React.FC<IHeaderWidth> = ({ width }) => {
  const { t } = useTranslation();
  const auth = useAppSelector((state) => state?.user);
  const about_me = useAppSelector((state) => state?.about_me);
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <Link to={"/my-information"}> {t("Profile")} </Link>,
    },
    {
      key: "2",
      label: <span className="hover:cursor-pointer"><LogoutButton /></span>,
    },
  ];

  const active_lang = localStorage.getItem("i18lang");

  return (
    <header className="w-full fixed z-10 shadow-lg bg-white">
      <div className={`w-full sm:block hidden mx-auto bg-main_color py-4 text-white`}>
        <div className="container mx-auto px-5">
          <div className="w-full flex justify-between items-center gap-10">
            <div className="flex items-center justify-between gap-5 font-montserrat text-xs">
              <a href="https://googlemaps.com" target="_blank" className="flex items-center max-[851px]:hidden" >
                <HiOutlineLocationMarker size={18} className="mr-2" />
                {t("Tashkent Uzbekistan")}
              </a>
              <a href="tel:+998555206050" className="flex items-center max-[851px]:hidden" >
                <FiPhone size={18} className="mr-2" />
                +998 (55) <span className="font-bold ml-1"> 520 60 50</span>
              </a>
              <a href="mailto:info@udrc.uz" className="flex items-center font-bold" >
                <IoMailOutline size={18} className="mr-2" /> info@udrc.uz
              </a>
              <div className=" w-[1px] h-5 bg-white"></div>
              <a href="https://www.linkedin.com/company/tashkent-mediation-center/" target="_blank"><FaLinkedin size={18} /></a>
              <a href="https://www.facebook.com/profile.php?id=61568589883444" target="_blank"><ImFacebook2 size={18} /></a>
              <a href="https://t.me/mediation_centre" target="_blank"><FaTelegramPlane size={18} /></a>
              <a href="https://www.instagram.com/tmcentre?igsh=MTRvc3NpZDM4NHFxMA==" target="_blank"><AiFillInstagram size={20} /></a>
            </div>
            <div className="flex items-center">
              <button className={`text-lg ${ active_lang == "uz" ? "text-[#FFFFFF] font-bold" : "text-[#8DB8D2]" }`}
                onClick={() => { localStorage.setItem("i18lang", `uz`); i18next.changeLanguage("uz"); }}>UZ</button>
              <button className={`mx-3 border-l-2 border-r-2 border-white px-3 py-0 text-lg ${active_lang == "ru" ? "text-[#FFFFFF] font-bold" : "text-[#8DB8D2]"}`}
                onClick={() => { localStorage.setItem("i18lang", `ru`); i18next.changeLanguage("ru");}}>RU</button>
              <button className={`text-lg ${active_lang == "en" ? "text-[#FFFFFF] font-bold" : "text-[#8DB8D2]"}`}
                onClick={() => { localStorage.setItem("i18lang", `en`); i18next.changeLanguage("en") }}>EN</button>
              {!auth.isLoggedIn ? (
                <Link to={"/login"} className="font-medium ml-5 text-lg">{t("Sign in")}</Link>) : (
                <Dropdown menu={{ items }} className="ml-5 block" >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space>
                      <div className="flex hover:cursor-pointer py-2 sm:px-4 max-sm:pl-2 hover:rounded-full">
                        {about_me?.about_me && about_me?.about_me?.avatar?.contentUrl ? (
                          <img src={`${FILE_URL}${about_me?.about_me && about_me?.about_me?.avatar?.contentUrl}`} alt="avatar" className="w-[36px] h-[36px] rounded-[50%]"/>) : (
                          <img src={Avatar} alt="Avatar" />)}
                        <div className="ml-2 max-sm:hidden flex items-center">
                          <h4 className="text-sm font-semibold">
                            {about_me?.about_me?.lastName}
                            {String(about_me?.about_me?.firstName).charAt(0)}.
                          </h4>
                        </div>
                      </div>
                    </Space>
                  </a>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-5 lg:block hidden">
        <div className="w-full flex items-center justify-between  mx-auto py-2 gap-5">
          <Link to={"/"} className="flex items-center">
            {active_lang == "uz" ? (<img src={Arbitrator_new_logo_uz} alt="logo" className="1141:min-w-[160px] min-w-[100px] 1141:h-[65px] h-[55px] mr-5"/>) : 
			active_lang == "ru" ? ( <img src={Arbitrator_new_logo_ru} alt="logo" className="1141:min-w-[160px] min-w-[100px] 1141:h-[65px] h-[55px] mr-5" />) : 
			(<img src={Arbitrator_new_logo_eng} alt="logo" className="1141:min-w-[160px] min-w-[100px] 1141:h-[65px] h-[55px] mr-5" />)}
          </Link>
          <div className="flex items-center">
            <div className="flex 1197:text-xl 1099:text-lg text-base 1269:gap-16 gap-10 items-center">
              <Link to={"/udrc-(tmc)/:147"}>{t("About us")}</Link>
              {/* <Link to={"/international-arbitration-rules/:160"}>{t("International arbitration")}</Link> */}
              <Link to={"/basic-information/:228"}>{t("Arbitration court")}</Link>
              <Link to={"/basic-information/:180"}>{t("Mediation")}</Link>
            </div>
          </div>
          <div className="flex items-center">
            <Link to={auth.isLoggedIn ? "/my-application" : "/login"} className="bg-main_color rounded text-white px-3 py-1 text-center max-1099:text-sm" >{t("Request arbitration / mediation")}</Link>
          </div>
        </div>
      </div>

      <div className="conatainer mx-auto px-5 ">
        <div className="mx-auto max-w-[1681px]"><HeaderResponsiveWithProvider /></div>
      </div>
    </header>
  );
};

export default Header;